import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import * as subjectService from "../../../services/subject.services";
import CustomPagination from "../../../common/custompagination";
import Sorting from "../../../common/sorting";
import Breadcrums from "../../../common/breadcrumbs";
import CustomRangepicker from "../../../common/rangepicker";
import { SWAL_SETTINGS } from "../../../../../utils/Constants";
import {
  formateDateWithMonthAdmin,
  handleServerValidations,
  TrimText,
  usePermission,
} from "../../../../../utils/commonfunction";
import { Placeholder, Tooltip, Whisper } from "rsuite";

const SubjectTable = () => {
  const { can } = usePermission();
  const { t } = useTranslation();
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [statsupdate, setStatusUpdate] = useState(false);
  const [datalength, setDataLength] = useState("");
  const [itemperpage] = useState(10);
  const [sorting, setSorting] = useState({});
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [search, setSearch] = useState({});
  const [globalsearch, setGlobalSearch] = useState("");
  const [resetdate, setResetDate] = useState(false);

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: "Subjects", url: "" },
  ];

  useEffect(() => {
    const getData = setTimeout(() => {
      if (search) {
        setLoader(true);
        const formData = new FormData();
        formData.append("page", params.pgno || 1);
        formData.append("per_page", itemperpage);
        formData.append("sort", JSON.stringify(sorting));
        formData.append("search", JSON.stringify(search));
        formData.append("global_search", globalsearch);
        subjectService
          .List(formData)
          .then((data) => {
            setDataLength(data?.data?.total_records || 0);
            setList(data && data.data && data.data.list ? data.data.list : []);
            setPage(data && data.data && data.data.page ? data.data.page : 1);
            setLoader(false);
          })
          .catch((error) => {
            console.log("error ====> ", error);
            setLoader(false);
          });
      }
    }, 300);
    return () => clearTimeout(getData);
  }, [location, statsupdate, sorting, search, globalsearch, params.pgno, itemperpage]);

  const handleSort = (e, column) => {
    setDefaultSorting(false);
    let sort = { order: 0, column: column };
    if (e.target.classList.contains("assc")) {
      sort.order = -1;
    } else {
      sort.order = 1;
    }
    setSorting(sort);
  };

  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (String(value).length > 0) {
      sr[key] = value;
    } else {
      delete sr[key];
    }
    setSearch(sr);
  };

  const resetFilter = () => {
    setSearch({});
    setGlobalSearch("");
    setSorting({});
    setDefaultSorting(true);
    setResetDate(!resetdate);
    setStatusUpdate(!statsupdate);
  };

  const goToEdit = (row) => {
    navigate(`/admin/cms/subjects/${params.pgno || 1}/edit/${row._id}`);
  };

  const ChangeStatus = (data, Num) => {
    const formData = new FormData();
    let ids = Array.isArray(data) ? data : [data];
    formData.append("o_id", JSON.stringify(ids));
    formData.append("status", Num);
    Swal.fire({
      customClass: "swal-wide",
      title: t("msg_are_you_sure"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("btn_yes"),
      cancelButtonText: t("btn_cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        subjectService
          .Status(formData)
          .then((response) => {
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              setStatusUpdate(!statsupdate);
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("error===>", error);
          });
      }
    });
  };

  function Deletefunction(data) {
    Swal.fire({
      customClass: "swal-wide",
      title: t("msg_are_you_sure"),
      text: t("you_not_be_able_to_revert_this"),
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: t("btn_cancel"),
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("btn_yes_delete"),
    }).then((result) => {
      if (result.isConfirmed) {
        const formdata = new FormData();
        let ids = [data._id];
        formdata.append("o_id", JSON.stringify(ids));
        subjectService
          .Delete(formdata)
          .then((response) => {
            setStatusUpdate(!statsupdate);
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("deleteError", error);
          });
      }
    });
  }

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">Subjects</h6>
              <div className="d-flex align-items-center">
                <div className="form-group mb-0 me-3">
                  <div className="form-group mb-0 rangepicker_container filter_design">
                    <i className="fa fa-search calender_icon"></i>
                    <input
                      type="search"
                      className="form-control"
                      value={globalsearch}
                      placeholder={t("input_placeholder_search", "Search")}
                      onChange={(e) => setGlobalSearch(e.target.value)}
                    />
                  </div>
                </div>
                <div className="me-3">
                  <CustomRangepicker
                    GetDateRange={(e) => prepareSearch("createdAt", e)}
                    resetdate={resetdate}
                  />
                </div>

                <button
                  type="reset"
                  value="Reset"
                  onClick={resetFilter}
                  className="btn btn-warning float-right mr-2"
                >
                  {t("btn_reset_filter")}
                </button>
                {can("/admin/cms/subjects/add") && (
                  <button
                    className="btn ripple btn-main-primary signbtn mr-2"
                    onClick={() => navigate(`/admin/cms/subjects/add`)}
                  >
                    {t("btn_add_new")}
                  </button>
                )}
              </div>
            </div>

            {loader ? (
              <Placeholder.Paragraph
                className="w-100"
                rowHeight={30}
                rowSpacing={5}
                active={true}
                rows={7}
              />
            ) : (
              <>
                <div className="table-responsive min-h-400">
                  <table className="table table-bordered border-t0 card-table border-top text-nowrap w-100">
                    <thead>
                      <tr>
                        <th className="position-relative select_head">
                          <span>{t("list_heading_sno")}</span>
                        </th>
                        <th>
                          <div className="sorting_column">
                            <span>Name</span>
                            <Sorting
                              sort={sorting}
                              handleSort={handleSort}
                              defaultSorting={defaultSorting}
                              column="name"
                            />
                          </div>
                        </th>
                        <th className="status_head">{t("list_heading_status")}</th>
                        <th className="created_head">
                          <div className="sorting_column">
                            <span>{t("list_heading_created_date")}</span>
                            <Sorting
                              sort={sorting}
                              handleSort={handleSort}
                              defaultSorting={defaultSorting}
                              column="createdAt"
                            />
                          </div>
                        </th>
                        <th className="action_head">{t("list_heading_action")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {list.length ? (
                        list.map((row, i) => (
                          <tr key={i}>
                            <td>{row ? (page - 1) * itemperpage + i + 1 : null}</td>
                            <td>
                              <div className="d-flex">
                                {row?.name ? TrimText(row.name, 50) : "N/A"}
                              </div>
                            </td>
                            <td>
                              <label
                                className={
                                  "custom-switch cp" +
                                  (row.status !== 1 ? " e_none" : "")
                                }
                              >
                                <input
                                  className="custom-switch-input cp"
                                  type="checkbox"
                                  checked={row?.status === 1}
                                  disabled={!can("/admin/cms/subjects/edit")}
                                  onChange={() =>
                                    can("/admin/cms/subjects/edit") && ChangeStatus(row?._id, row?.status === 1 ? 0 : 1)
                                  }
                                />
                                <span className="custom-switch-indicator cp"></span>
                              </label>
                            </td>
                            <td>
                              {row.createdAt
                                ? formateDateWithMonthAdmin(row.createdAt)
                                : "N/A"}
                            </td>
                            <td>
                              <div
                                className="btn-toolbar table-actions"
                                role="toolbar"
                                aria-label="Toolbar with button groups"
                              >
                                <div
                                  className="btn-group btn-group-sm"
                                  role="group"
                                  aria-label="Second group"
                                >
                                  {can("/admin/cms/subjects/edit") && (
                                    <Whisper
                                      placement="top"
                                      controlId="control-id-hover"
                                      trigger="hover"
                                      speaker={
                                        <Tooltip style={{ fontWeight: "bold" }}>
                                          Edit
                                        </Tooltip>
                                      }
                                    >
                                      <button
                                        type="button"
                                        className="btn edit"
                                        onClick={() => goToEdit(row)}
                                      >
                                        <i className="ri-pencil-fill"></i>
                                      </button>
                                    </Whisper>
                                  )}
                                  {can("/admin/cms/subjects/delete") && (
                                    <Whisper
                                      placement="top"
                                      controlId="control-id-hover"
                                      trigger="hover"
                                      speaker={
                                        <Tooltip style={{ fontWeight: "bold" }}>
                                          Delete
                                        </Tooltip>
                                      }
                                    >
                                      <button
                                        type="button"
                                        className="btn delete"
                                        onClick={() => Deletefunction(row)}
                                      >
                                        <i className="ri-delete-bin-6-fill"></i>
                                      </button>
                                    </Whisper>
                                  )}
                                </div>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={10} className="text-center">
                            {t("msg_no_records")}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <div id="example1_info" role="status" aria-live="polite">
                  <b>
                    {t("msg_total_records")} : {datalength ? datalength : "0"}
                  </b>
                </div>
                {datalength && datalength > 0 ? (
                  <CustomPagination
                    datalength={datalength}
                    itemperpage={itemperpage}
                    currentPage={page}
                    setPage={setPage}
                    pageRoute={[
                      {
                        name: "",
                        path: "/admin/cms/subjects/list",
                      },
                    ]}
                  />
                ) : (
                  ""
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default SubjectTable;
